<template>
    <div class="f-count-down"
      :style="{background: wrapBackground, color: wrapColor}">
        <div class="content" :class="{'absolute': backgroundImage}">
            <slot></slot><span :style="{background: spanBackground}" v-if="days>0">{{ days }}</span><em v-if="days>0">{{ showType == 1 ? ':' : '天' }}</em><span :style="{background: spanBackground}">{{ hours }}</span>{{ showType == 1 ? ':' : '时' }}<span :style="{background: spanBackground}">{{ minutes }}</span>{{ showType == 1 ? ':' : '分' }}<span :style="{background: spanBackground}">{{ seconds }}</span>{{ showMs == true ? '.' : '' }}<span :style="{background: spanBackground}" v-if='showMs'>{{ mseconds }}</span>{{ showType == 1 ? '' : '秒' }}
        </div>
        <img :src="backgroundImage" v-if="backgroundImage" class="bgimg">
    </div>
</template>

<script>
    export default {
        name: 'f-count-down',
        data () {
            let leftCount = this.leftCount
            return {
                timeID: null,
                initCount: leftCount
            }
        },
        computed: {
            days () {
                var day = Math.floor(this.initCount / (3600 * 24))
                return ('00' + day).slice(-2)
            },

            hours () {
                var hour = Math.floor((this.initCount % (3600 * 24)) / 3600)
                return ('00' + hour).slice(-2)
            },

            minutes () {
                var minute = Math.floor((this.initCount % 3600) / 60)
                return ('00' + minute).slice(-2)
            },

            seconds () {
                var second = Math.floor(this.initCount % 60)
                return ('00' + second).slice(-2)
            },

            mseconds () {
                var mseconds = Math.floor((this.initCount * 10) % 10)
                return mseconds
            }
        },
        props: {
            leftCount: {
                type: Number,
                default: 0
            },
            backgroundImage: {
                type: String
            },
            wrapBackground: {
                type: String,
                default: '#ff3444'
            },
            wrapColor: {
                type: String,
                default: '#ffffff'
            },
            spanBackground: {
                type: String,
                default: '#000'
            },
            showType: {
                type: Number,
                default: 0
            },
            showMs: {
                type: Boolean,
                default: false
            }
        },
        mounted () {
            var self = this
            if (this.initCount > 0) {
                this.timeID = setInterval(function () {
                    if (self.showMs) {
                        self.initCount = self.initCount - 0.1
                        self.initCount = self.initCount.toFixed(1)
                    } else {
                        self.initCount--
                    }
                    if (self.initCount <= 0) {
                        clearInterval(self.timeID)
                        self.$emit('count-end')
                    }
                }, self.showMs ? 100 : 1000)
            }
        },
        beforeDestroy () {
            if (this.timeID) {
                clearInterval(this.timeID)
            }
        }
    }
</script>

<style lang="stylus">
    .f-count-down
        font-size: 0
        color: #ffffff
        text-align: center
        position: relative

        .bgimg
            display: block
            vertical-align: top
            width: 100%

        .content
            height: 30px
            font-size: 11px
            line-height 30px
            text-align: center

            em
                font-style: normal
        .absolute
            position: absolute
            top: 50%
            left: 0
            right: 0
            bottom: 0
            width: 100%
            margin-top: -15px
            z-index: 10
        
            span
                display: inline-block
                width: 16px
                height: 15px
                line-height: 13px
                font-size: 13px
                font-weight: bold
                background: #000
                border-radius: 2px
                vertical-align: top
                margin-top: 6px
                margin-right: 3px
                letter-spacing: 1px
                margin-left: 1px
                padding: 2px 2px 0 2px
                vertical-align: top
</style>


// WEBPACK FOOTER //
// count-down.vue?1a6b1596